// extracted by mini-css-extract-plugin
export var link = "_9-0";